module.exports = __webpack_public_path__ + "static/media/KP_04.931fd889.jpg";